

















import Vue from 'vue'
import QboConnectButton from '@/components/QboConnectButton.vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    components: { QboConnectButton },
    data: () => ({
        loading: false
    }),
    mounted() {
        //  Get the 'sender' flag from the url
        const sender = this.$route.query.sender

        //  If the sender is 'disconnectFromAppstore', pop disconnect message
        if (sender === 'disconnectFromAppstore') this.popDisconnected()

        //  If the sender is 'error', pop connection error message
        if (sender === 'error') this.popConnectionError()
    },
    computed: {
        ...mapGetters([
            'qboAccount',
            'qboConnection',
            'dataProviderSyncProgress',
            'tenant'
        ]),
        status(): string {
            if (this.dataProviderSyncProgress) return 'Syncing Data'
            if (this.qboConnection) return 'Connected'
            return 'Disconnected'
        }
    },
    methods: {
        popConnectionError(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Error Connecting to QuickBooks.',
                icon: 'error',
                text: `There was a problem connecting "${this.tenant.company_name}" to QuickBooks Online. You may be trying to connect to a company that is already connected. If you think you received this message in error, please refresh your browser and try to connect again`
            })
        },
        popDisconnected(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Disconnected from QuickBooks Online',
                icon: 'mdi-check',
                text: `You have been disconnected from QuickBooks Online. Your subscription with MessageDesk is still active. If you would like to make changes to your subscription, please visit the subscription link located in the account menu.`
            })
        },
        qboDisconnectConfirm(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Disconnect from QuickBooks Online?',
                text: `Are you sure you want to disconnect from QuickBooks Online?`,
                icon: 'mdi-alert-circle',
                color: 'yellow darken-2',
                callback: (result: boolean): void => this.qboDisconnect(result),
                admin: true
            })
        },
        async qboDisconnect(dialog_result: boolean): Promise<void> {
            //  If the dialog result is false, do nothing
            if (!dialog_result) return

            //  Start the loading spinner
            this.loading = true

            //  Send the request to the API
            const response = await this.$store.dispatch('qboDisconnect')

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, do nothing
            if (!response) return

            //  Else, notify the user of success
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Disconnected from QuickBooks Online',
                text: `You have been successfully disconnected from QuickBooks Online.`,
                icon: 'mdi-link-variant-off',
                color: 'red darken-1'
            })
        }
    }
})
